'use client';

import { action, makeObservable, observable } from 'mobx';

export class InventoryCounterStore {
  counter: number = 10;

  count: number = 0;

  currentPage: number = 1;

  previousPage: number | null = null;

  nextPage: number | null = 2;

  loader: boolean = true;

  constructor() {
    makeObservable(this, {
      counter: observable,
      count: observable,
      currentPage: observable,
      previousPage: observable,
      nextPage: observable,
      loader: observable,
      setCurrentPage: action.bound,
      setPreviousPage: action.bound,
      setNextPage: action.bound,
      setCount: action.bound,
      setCounter: action.bound,
      setLoader: action.bound,
      resetStore: action.bound,
    });
  }

  setCurrentPage(page: number) {
    this.currentPage = page;
  }

  setPreviousPage(page: number | null) {
    this.previousPage = page;
  }

  setNextPage(page: number | null) {
    this.nextPage = page;
  }

  setCounter(counter: number) {
    // number of rows per page
    this.counter = counter;
  }

  setCount(count: number) {
    this.count = count;
  }

  setLoader(value: boolean) {
    this.loader = value;
  }

  resetStore() {
    this.counter = 10;
    this.count = 0;
    this.previousPage = null;
    this.nextPage = 2;
    this.loader = true;
  }
}

export const modelInventoryCounterStore = new InventoryCounterStore();
export const useCaseInventoryCounterStore = new InventoryCounterStore();
export const datasetInventoryCounterStore = new InventoryCounterStore();
export const assessmentInventoryCounterStore = new InventoryCounterStore();
export const governanceEvaluationInventoryCounterStore = new InventoryCounterStore();
